import React, { useState } from 'react'
import styles from './ImageWithFallback.module.scss'

const ImageWithFallback = ({ 
  src, 
  alt = '', 
  fallbackIcon = '🖼️',
  fallbackText = 'Нет изображения',
  className = '',
  ...props 
}) => {
  const [imageError, setImageError] = useState(false)
  const [imageLoaded, setImageLoaded] = useState(false)

  const handleImageError = () => {
    setImageError(true)
    setImageLoaded(true)
  }

  const handleImageLoad = () => {
    setImageLoaded(true)
  }

  // Если нет src или была ошибка - показываем fallback
  if (!src || imageError) {
    return (
      <div className={`${styles.fallback} ${className}`}>
        <span className={styles.fallbackIcon}>{fallbackIcon}</span>
        <span className={styles.fallbackText}>{fallbackText}</span>
      </div>
    )
  }

  return (
    <>
      <img 
        src={src} 
        alt={alt}
        className={`${className} ${imageLoaded ? styles.loaded : styles.loading}`}
        onError={handleImageError}
        onLoad={handleImageLoad}
        loading="lazy"
        {...props}
      />
      {!imageLoaded && (
        <div className={`${styles.fallback} ${styles.loading} ${className}`}>
          <span className={styles.fallbackIcon}>{fallbackIcon}</span>
          <span className={styles.fallbackText}>Загрузка...</span>
        </div>
      )}
    </>
  )
}

export default ImageWithFallback
